<div class="media-asset">
  <div class="media-asset-visualizer !items-start">
    <iframe #iframe id="bannerIframe" title="HTML Banner"></iframe>
  </div>

  <div *ngIf="toolbar && asset && (asset.expiryDate | dateNotExpired)" class="media-asset-toolbar">
    <ul class="media-asset-toolbar-list media-asset-toolbar-area">
      <li class="media-asset-toolbar-item">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="reloadBannerIFrame()" mat-menu-item>
            <mat-icon>refresh</mat-icon>
            <span i18n>Refresh</span>
          </button>
          <button (click)="openBannerInNew()" mat-menu-item>
            <mat-icon>open_in_new</mat-icon>
            <span i18n>Open in new</span>
          </button>
        </mat-menu>
      </li>
    </ul>
  </div>
</div>
